import Swiper from 'swiper';
import 'swiper/css';
import "./css/swiper.scss";

const swiper = new Swiper('.swiper-block', {
    slidesPerView: 3,
    spaceBetween: 30,
});
